<template>
  <div
    >
    <edit
      :selected="selected"
      receiptType="owner"
      ref="edit"
      v-if="selected"
      @reload="$emit('reload')"
      ></edit>

    <div
      class="font-weight-medium primary lighten-2 white--text px-3 py-1"
      @click="expand = !expand"
      style="cursor: pointer"
      >
      <div>
        {{ payment[0] == 'null' ? 'Fuera de contrato' : payment[0] }}
      </div>
    </div>

    <v-expand-transition>
      <div
        v-if="expand"
        class="text--primary"
        >
        <template
          v-for="(charge, i) in orderedCharges"
          >
          <div
            class="d-flex align-center px-3"
            :class="{ 'ml-8': !(charge.concept == 'Alquiler' && i == 0), 'rounded-0': (charge.concept == 'Alquiler' && i == 0) }"
            :style="!(charge.concept == 'Alquiler' && i == 0) ? 'border-left: 1px solid #0000001f' : 'border: 1px solid #586279; border-left: 8px solid #586279'"
            style="gap: 8px"
            >
            <div>
              <v-icon
                color="primary"
                @click.stop="pay(charge)"
                >
                {{ charge.state == 'paid' ? 'mdi-check-circle' : 'mdi-check-circle-outline' }}
              </v-icon>
            </div>
            <v-row
              no-gutters
              class="mt-2"
              align="center"
              >
              <v-col
                cols="5"
                >
                <div
                  class="caption d-flex align-center"
                  style="gap: 4px"
                  >
                  #{{ charge.id }} {{ charge.taxableTag == 'Building' ? '- Expensas' : '' }}

                  <v-icon
                    v-if="charge.concept == 'Alquiler' && !(charge.referralType == 'User' && charge.referralId == client.id)"
                    color="primary lighten-2"
                    small
                    >
                    mdi-home
                  </v-icon>

                  <v-tooltip 
                    color="primary"
                    right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="payment.thirdPartyTransfer"
                        v-on="on"
                        v-bind="attrs"
                        size="18"
                        color="primary lighten-1"
                        >
                        mdi-bank-transfer
                      </v-icon>
                    </template>
                    <span>Transferencia directa al locador por parte del locatario.</span>
                  </v-tooltip>
                </div>

                <div
                  class="text-body-2"
                  >
                  <span
                    class="font-weight-medium"
                    >
                    <template
                      v-if="charge.concept == 'Alquiler' && charge.referralType == 'User' && charge.referralId == client.id"
                      >
                      Comisión
                    </template>
                    <template
                      v-else
                      >
                      {{ charge.concept }}
                    </template>
                  </span>
                  - {{ (new Date(charge.dueDate)).toLocaleString('default', { month: 'long' }) }}
                </div>
              </v-col>

              <v-col
                cols="2"
                class="text-right font-weight-medium"
                :class="charge.total >= 0 ? '' : 'red--text'"
                @click="select(charge)"
                style="cursor: pointer"
                >
                <div
                  v-if="charge.total < 0"
                  :style="!(charge.concept == 'Alquiler' && i == 0) ? 'margin-right: 11px' : ''"
                  style="position: relative"
                  >
                  <template
                    v-if="charge.chargebacks.length"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-alert
                        </v-icon>
                      </template>
                      <span>Con intereses {{ charge.chargebacks[0].active ? 'habilitados' : 'deshabilitados' }}</span>
                    </v-tooltip>
                  </template>

                  <template
                    v-if="charge.children.length"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-source-branch
                        </v-icon>
                      </template>
                      <span>Contiene pagos parciales</span>
                    </v-tooltip>
                  </template>

                  {{ price(charge) }}

                  <v-tooltip
                    v-if="!charge.lastingAmount"
                    color="primary"
                    bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        small
                        style="position: absolute; top: -12px; right: -12px"
                        >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Haga click en el monto para editar el valor del cobro.</span>
                  </v-tooltip>
                </div>
              </v-col>

              <v-col
                cols="2"
                class="text-right font-weight-medium"
                :class="charge.total >= 0 ? '' : 'red--text'"
                @click="select(charge)"
                style="cursor: pointer; position: relative"
                >
                <div
                  v-if="charge.total >= 0"
                  :style="!(charge.concept == 'Alquiler' && i == 0) ? 'margin-right: 11px' : ''"
                  >
                  <template
                    v-if="charge.chargebacks.length"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-alert
                        </v-icon>
                      </template>
                      <span>Con intereses {{ charge.chargebacks[0].active ? 'habilitados' : 'deshabilitados' }}</span>
                    </v-tooltip>
                  </template>

                  <template
                    v-if="charge.children.length"
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          size="20"
                          class="mt-n1"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          mdi-source-branch
                        </v-icon>
                      </template>
                      <span>Contiene pagos parciales</span>
                    </v-tooltip>
                  </template>

                  <v-tooltip
                    v-if="!charge.lastingAmount"
                    color="primary"
                    bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        small
                        style="position: absolute; top: -12px; right: -12px"
                        >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Haga click en el monto para editar el valor del cobro.</span>
                  </v-tooltip>

                  {{ price(charge) }}
                </div>
              </v-col>

              <v-col
                cols="3"
                class="text-right"
                >
                <template
                  v-if="charge.counterpart && charge.referralId != client.id" 
                  >
                  <template
                    v-if="charge.counterpart.paidAt"
                    >
                    {{ (new Date(charge.counterpart.paidAt)).toLocaleDateString() }}
                  </template>

                  <template
                    v-else
                    >
                    <div>
                      Pendiente
                    </div>

                    <div
                      class="caption"
                      >
                      (Locatario)
                    </div>
                  </template>
                </template>

                <template
                  v-else
                  >
                  <template
                    v-if="charge.paidAt"
                    >
                    {{ (new Date(charge.paidAt)).toLocaleDateString() }}
                  </template>

                  <template
                    v-else
                    >
                    Pendiente
                  </template>
                </template>
              </v-col>

              <v-col
                cols="12"
                class="mt-2"
                >
                <v-divider
                  v-if="!(charge.concept == 'Alquiler' && i == 0)"
                  ></v-divider>
              </v-col>
            </v-row>
          </div>
        </template>
      </div>
    </v-expand-transition>

    <v-divider
      class="white fill-width"
      ></v-divider>
  </div>
</template>

<script>
import Edit from '@/components/payments/tenants/Edit'

import { EditPayment, Pay, SwitchChargeback } from '@/graphql/mutations/payments'

export default {
  data: () => ({
    expand: false,
    dialog: false,
    selected: null
  }),

  props: {
    payment: {
      type: Array,
      required: true
    },

    client: {
      type: Object,
      required: true
    },

    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    orderedCharges () {
      var ordered = this.payment[1].sort( (a, b) => {
        if (a.concept.toUpperCase() < b.concept.toUpperCase()) {
          return 1;
        }
        if (a.concept.toUpperCase() > b.concept.toUpperCase()) {
          return -1;
        }
        // a must be equal to b
        return 0;
      })

      ordered = ordered.sort( (x,y) => {
        return (x.concept == 'Alquiler' && !(x.referralType == 'User' && x.referralId == this.client.id)) ? -1 : (y.concept == 'Alquiler' && !(y.referralType == 'User' && y.referralId == this.client.id)) ? 1 : 0; 
      });

      return ordered
    }
  },

  created () {
    this.expand = this.expanded
  },

  methods: {
    pay (charge) {
      this.loading = true

      this.$apollo.mutate({
        mutation: Pay,
        variables: {
          input: {
            paymentId: charge.id,
            setReceipt: true,
            receiptType: 'tenant'
          }
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.loading = false
        charge.state = charge.state == 'paid' ?  'pending' : 'paid'
        charge.paidAt = charge.state == 'paid' ? (new Date) : null

        this.$emit('reload')
      })
    },

    price (payment) {
      const options = { style: 'currency', currency: payment.currency };
      const numberFormat = new Intl.NumberFormat('es-AR', options);

      return numberFormat.format(Math.abs(payment.lastingAmount))
    },

    select (payment) {
      this.selected = payment

      this.$nextTick( () => {
        this.$refs.edit.dialog = true
      })
    },
  },

  components: {
    Edit
  }
}
</script>
